import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import FileBase64 from "react-file-base64";
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";
import addRataStatus from "../services/addRataStatus";
import saveFile from "../services/saveFile";
import Cookies from "universal-cookie";
import uuid from "react-uuid";
import Constants from "../utils/consts";
import Button from "./Button";
import fileImage from "../images/file.png";
import MyDatePicker from "./DatePickerIta";
import $ from "jquery";
import moment from "moment";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./css/editor.css";
import ImageSilentInput from "./ImageSilentInput";

export default class RataStatusWidget extends React.Component {
  constructor(props) {
    super(props);

    this.rataDateRef = React.createRef();
    this.importoRef = React.createRef();

    // Inizializziamo i valori con le props se disponibili
    this.importo = props.rata ? props.rata.importo : 0;
    this.data = props.rata ? props.rata.data : "";

    console.log("RataStatusWidget constructor - valori iniziali:", {
      importo: this.importo,
      data: this.data,
      rata: props.rata,
    });

    this.options = [];
    this.options.push({ value: "NON PAGATA", label: "NON PAGATA" });
    this.options.push({ value: "DA VERIFICARE", label: "DA VERIFICARE" });
    this.options.push({ value: "PAGATA", label: "PAGATA" });

    // Inizializziamo anche l'opzione corrente
    this.option =
      this.options.find((o) => o.value == props.status) || this.options[0];

    this.files = [];
    this.newFiles = [];
    this.deletedFiles = [];
    this.newNote = undefined;

    this.state = {
      option: this.option,
      note: props.rata ? props.rata.note : "",
    };
  }

  onContentStateChange = (contentState) => {
    this.savedEnabled = true;
    console.log("as HTML:", draftToHtml(contentState));
    this.setState({ contentState });
  };

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.rata) != JSON.stringify(this.props.rata)) {
      console.log("RataStatusWidget - rata cambiata:", {
        prevRata: prevProps.rata,
        newRata: this.props.rata,
        status: this.props.status,
      });

      this.option =
        this.options.find((o) => o.value == this.props.status) ||
        this.options[0];
      this.importo = this.props.rata ? this.props.rata.importo : 0;

      // Gestiamo la data in modo più robusto
      if (this.props.rata && this.props.rata.data) {
        this.data = this.props.rata.data;
      } else {
        this.data = "";
      }

      console.log("RataStatusWidget - valori inizializzati:", {
        importo: this.importo,
        data: this.data,
        option: this.option,
      });

      this.setState({
        option: this.option,
        note: this.props.rata ? this.props.rata.note : "",
      });
    }
    this.newFiles = [];
    this.deletedFiles = [];
    this.newNote = undefined;
  }

  render() {
    if (this.props.rata == undefined) return null;

    this.files = [];
    var tempArr = this.props.rata.files ? this.props.rata.files.split(";") : [];
    for (var t of tempArr)
      if (t != "" && this.deletedFiles.indexOf(t) == -1) this.files.push(t);
    for (var t of this.newFiles)
      if (t != "" && this.deletedFiles.indexOf(t) == -1) this.files.push(t.src);

    const that = this;
    // Formattiamo la data per il DatePicker - gestiamo diversi formati
    let rataDataFormatted = null;
    console.log("RataStatusWidget render - this.data:", this.data);

    if (this.data && this.data !== "") {
      // Proviamo prima il formato DD-MM-YYYY
      let momentDate = moment(this.data, "DD-MM-YYYY");

      // Se non è valido, proviamo il formato DD-MMM-YYYY (es: 26-May-2025)
      if (!momentDate.isValid()) {
        momentDate = moment(this.data, "DD-MMM-YYYY");
      }

      // Se non è valido, proviamo altri formati comuni
      if (!momentDate.isValid()) {
        momentDate = moment(this.data);
      }

      if (momentDate.isValid()) {
        rataDataFormatted = momentDate.format("YYYY-MM-DD");
        console.log("Data formattata per DatePicker:", rataDataFormatted);
      } else {
        console.log("Data non valida:", this.data);
      }
    } else {
      console.log("Data vuota o non definita");
    }

    return (
      <div
        key={Math.random()}
        style={{ display: this.props.show == true ? "block" : "none" }}
      >
        <div style={container}>
          <div style={mainClass}>
            <div
              style={closeBtn}
              onClick={() => {
                this.setState({ visible: false });
                this.props.onClose();
              }}
            >
              X
            </div>

            <div style={{ paddingLeft: "5px" }}>
              {this.props.rata.studente && (
                <div>
                  Nome:{" "}
                  {this.props.rata.studente.nome +
                    " " +
                    this.props.rata.studente.cognome}
                </div>
              )}
              <div>Corso: {this.props.rata.corso.name}</div>
              <MyDatePicker
                ref={this.rataDateRef}
                name="Data scadenza rata"
                value={rataDataFormatted}
                onChange={(data) => {
                  this.data = data;
                  console.log("Data cambiata:", data);
                }}
              />
              <TextInput
                ref={this.importoRef}
                name="Importo"
                value={this.importo}
                onChange={(text) => {
                  this.importo = text;
                }}
              />
            </div>

            {this.props.isStudent == true && (
              <>
                <SelectInput
                  key={Math.random()}
                  value={this.state.option}
                  name={"Stato:"}
                  options={this.options}
                  isMulti={false}
                  onChange={(option) => {
                    this.setState({
                      option: option,
                    });
                  }}
                />

                <TextInput
                  key={Math.random()}
                  name={"Note"}
                  value={this.newNote ? this.newNote : this.state.note}
                  onChange={(text) => {
                    this.newNote = text;
                  }}
                />

                {/* <div style={{ width: "100%", display: "inline-flex", overflow: "scroll" }}>
									{this.files.map(file => {
										return (
											<div>
												<a target="_blank" href={file}>
													<img src={fileImage} />
												</a>
												<div
													style={{
														position: "relative",
														top: "-90px",
														left: "30px",
														cursor: "pointer",
													}}
													onClick={() => {
														if (window.confirm("Eliminare l'immagine?") == false) return;
														this.deletedFiles.push(file);
														this.setState({});
													}}
												>
													X
												</div>
											</div>
										);
									})}
								</div>
								<ImageSilentInput
									name={"Aggiungi documento"}
									key={Math.random()}
									value={this.state.imageToLoad}
									onChange={async base64 => {
										const photoId = uuid();
										const cookies = new Cookies();
										const token = cookies.get("token", { path: "/" });
										const username = cookies.get("username", { path: "/" });

										let retPhotoObj = await saveFile(username, token, photoId, base64);
										const fileName = "http://" + Constants.mainUrl + retPhotoObj.name;
										this.newFiles.push({
											id: photoId,
											src: fileName,
											width: 1,
											height: retPhotoObj.height / retPhotoObj.width,
										});

										this.setState({});
									}}
								/> */}
              </>
            )}

            <Button
              callback={async () => {
                var filesString = "";
                for (var str of this.files) {
                  if (filesString != "") filesString = filesString + ";";
                  filesString = filesString + str;
                }

                var note =
                  this.newNote != undefined ? this.newNote : this.state.note;
                var rataDateRaw = this.rataDateRef.current.getDate();
                var rataDate;

                // Gestiamo diversi tipi di valori che può restituire getDate()
                if (rataDateRaw instanceof Date) {
                  rataDate = moment(rataDateRaw).format("DD-MM-YYYY");
                } else if (typeof rataDateRaw === "string") {
                  // Se è già una stringa, proviamo a parsarla
                  const parsed = moment(rataDateRaw);
                  rataDate = parsed.isValid()
                    ? parsed.format("DD-MM-YYYY")
                    : "Invalid date";
                } else {
                  // Se il DatePicker non ha una data valida, usiamo la data originale della rata
                  if (this.data && this.data !== "") {
                    // Convertiamo la data originale nel formato corretto
                    let originalMoment = moment(this.data, "DD-MMM-YYYY");
                    if (!originalMoment.isValid()) {
                      originalMoment = moment(this.data, "DD-MM-YYYY");
                    }
                    if (!originalMoment.isValid()) {
                      originalMoment = moment(this.data);
                    }
                    rataDate = originalMoment.isValid()
                      ? originalMoment.format("DD-MM-YYYY")
                      : "Invalid date";
                  } else {
                    rataDate = "Invalid date";
                  }
                }

                console.log("RataStatusWidget - SALVA clicked:", {
                  rataDateRaw: rataDateRaw,
                  rataDate: rataDate,
                  importo: this.importo,
                  status: this.state.option.value,
                  note: note,
                  rata: this.props.rata,
                  originalData: this.data,
                });

                if (rataDate == "Invalid date") {
                  console.log("RataStatusWidget - Data non valida!");
                  alert("Data non valida!");
                  return;
                }

                const cookies = new Cookies();
                const username = cookies.get("username", { path: "/" });
                const token = cookies.get("token", { path: "/" });
                var rata = this.props.rata;
                rata.id_corso = rata.corso.id;
                rata.id_studente = rata.studente.id;
                rata.importo = this.importo;
                rata.data = rataDate;
                rata.note = note;
                rata.files = filesString;
                rata.status = this.state.option.value;

                console.log("RataStatusWidget - Chiamando addRataStatus con:", {
                  id_corso: rata.corso.id,
                  id_studente: rata.studente.id,
                  data: rataDate,
                  importo: this.importo,
                  status: this.state.option.value,
                  files: filesString,
                  note: note,
                });

                let res = await addRataStatus(
                  username,
                  token,
                  rata.corso.id,
                  rata.studente.id,
                  rataDate,
                  this.importo,
                  this.state.option.value,
                  filesString,
                  note
                );
                console.log("RataStatusWidget - Risposta addRataStatus:", res);

                if (res.result == "ok") {
                  rata.saved = true; // Aggiungiamo un flag per indicare che è stato salvato
                  this.props.onClose(rata);
                } else {
                  alert(
                    "Si è verificato un errore durante il salvataggio della rata."
                  );
                }
              }}
              title="SALVA"
            ></Button>
          </div>
        </div>
      </div>
    );
  }
}

const mainClass = {
  position: "fixed",
  top: "25%",
  left: "25%",
  width: "50%",
  border: "1px solid black",
  background: "#ffffff",
  padding: "2%",
  height: "400px",
  overflow: "scroll",
};

const container = {
  position: "fixed",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  background: "#ffffff88",
  zIndex: 999,
};

const title = {
  position: "relative",
  textAlign: "center",
  width: "100%",
  fontWeight: "bold",
};

const bodyMsg = {
  border: "1px solid black",
  height: "200px",
};

const inputText = {
  width: "300px",
  padding: "10px",
};

const closeBtn = {
  position: "absolute",
  right: "1%",
  top: "1%",
  cursor: "pointer",
};
